import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { SearchMember } from './search-member/search-member.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './services/auth.service';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { HelperService } from './services/helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewChecked, AfterViewInit {
  title = 'POS';
  isModelOpen: boolean;
  loggedIn: boolean = false;
  loading: boolean = false;
  isTrialUser: Boolean = false;

  constructor(private modalService: NgbModal, private authService: AuthService, private router: Router,
    private helperService: HelperService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.isTrialUser = localStorage.getItem('isTrialUser') === 'TRUE' ? true : false;
    this.helperService.isTrial.subscribe((newValue) => {
      if (newValue != null) {
         this.isTrialUser = newValue;
      }
    });
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  searchAccountManagement(searchType) {
    const modalRef = this.modalService.open(SearchMember, { size: 'lg', centered: true });
    modalRef.componentInstance.searchType = searchType;
    modalRef.componentInstance.searchView = 'AccountManagement';
    modalRef.result.then(res => {
      if (res) {
      }
    }, res => {
      //
    });
  }

  navigateToLogin() {
    this.router.navigate(['account/login']);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  logout() {
    localStorage.clear();
    this.loggedIn = false;
    this.navigateToLogin();
  }

  search(searchType) {
    const modalRef = this.modalService.open(SearchMember, { size: 'lg', centered: true });
    modalRef.componentInstance.searchType = searchType;
    modalRef.componentInstance.searchView = 'search';
    modalRef.result.then(res => {
      if (res) {

      }
    }, res => {
      //
    });
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationStart) {
        this.helperService.setLoading(true);
      } else if ( event instanceof NavigationEnd || event instanceof NavigationCancel ) {
        this.helperService.setLoading(false);
      }
    });
  }
}
